import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import MyCertificateCard from "../../components/dashboard/MyCertificateCard";
import MyInfoCard from "../../components/dashboard/MyInfoCard";
import MyLectureCard from "../../components/dashboard/MyLectureCard";
// import MyQuizCard from "../../components/dashboard/MyQuizCard";
import MyReportCard from "../../components/dashboard/MyReportCard";
import { getStudentDashboardInfo } from "../../api";
import MySurveyCard from "../../components/dashboard/MySurveyCard";
import { useUpdateEffect } from "react-use";
import { useWindowFocus } from "../../util/common";

const StudentDashboardPage = ({ student_id, userId }) => {
  const queryClient = useQueryClient();
  const focused = useWindowFocus();
  const [info, setInfo] = useState({ loading: true, name: "", school: null });
  const [lecture, setLecture] = useState({ loading: true, list: null });
  const [survey, setSurvey] = useState({ loading: true, list: null });
  const [certificate, setCertificate] = useState({ loading: true, list: null });

  const getListQuery = async () => {
    const infoResult = await queryClient.fetchQuery(
      [`dashboard/${student_id}/info`],
      {
        queryFn: () => getStudentDashboardInfo(student_id, "info"),
      }
    );
    const lecResult = await queryClient.fetchQuery(
      [`dashboard/${student_id}/lecture`],
      {
        queryFn: () => getStudentDashboardInfo(student_id, "lecture"),
      }
    );
    const surResult = await queryClient.fetchQuery(
      [`dashboard/${student_id}/survey`],
      {
        queryFn: () => getStudentDashboardInfo(student_id, "survey"),
      }
    );
    const cerResult = await queryClient.fetchQuery(
      [`dashboard/${student_id}/certificate`],
      {
        queryFn: () => getStudentDashboardInfo(student_id, "certificate"),
      }
    );
    if (infoResult.result) {
      const { data } = infoResult;
      setInfo({ ...data, userId, loading: false });
    }
    if (lecResult.result) {
      const { data } = lecResult;
      setLecture(
        Object.keys(data).length
          ? { ...data, loading: false }
          : { list: [], loading: false }
      );
    }
    if (surResult.result) {
      const { data } = surResult;
      setSurvey(
        Object.keys(data).length
          ? { ...data, loading: false }
          : { list: [], loading: false }
      );
    }
    if (cerResult.result) {
      const { data } = cerResult;
      setCertificate(
        Object.keys(data).length
          ? { ...data, loading: false }
          : { list: [], loading: false }
      );
    }
  };

  useEffect(() => {
    if (student_id) {
      getListQuery();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student_id]);

  useUpdateEffect(() => {
    if (focused && student_id) {
      getListQuery();
    }
  }, [focused]);

  return (
    <div className="w-full mx-auto md:w-11/12 md:px-2">
      <h1 className="flex items-center font-sans font-bold break-normal text-cyan-500 px-2 py-4 text-xl md:text-2xl">
        대시보드
      </h1>
      <div className="grid grid-cols-6 gap-2 md:grid-rows-[minmax(200px,340px)_minmax(200px,288px)] mb-2">
        <MyInfoCard {...info} />
        <MyLectureCard {...lecture} />
        <MySurveyCard {...survey} id={student_id} />
        {/* <MyQuizCard /> */}
        <MyReportCard {...lecture} id={student_id} />
        <MyCertificateCard {...certificate} id={student_id} />
      </div>
    </div>
  );
};

export default StudentDashboardPage;
